import React, {FC} from "react"
import {formatTime, str2arr} from "@/helper/method";
import {GridItem} from "@/widget/GridItem/GridItem";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import isEmpty from "lodash/isEmpty";
import {useQueryTask} from "@/service/task.s";
import {Grid, Chip} from "@mui/material";
import {Face} from '@mui/icons-material';
import {isNumber} from "lodash";
import {ModeType, useDialogModal, useDrawerModal} from "@/store/global.c";

export interface ViewTaskProps {
    mode: ModeType
}

export const ViewTask: FC<ViewTaskProps> = ({mode}) => {
    const {id: drawerId} = useDrawerModal()
    const {id: dialogId} = useDialogModal()
    const {
        data: taskData,
        isLoading: taskLoading
    } = useQueryTask({id: (mode == 'dialog' ? dialogId : mode == 'drawer' ? drawerId : 0) as number}, isNumber(drawerId) || isNumber(dialogId))
    const task = taskData?.data
    const executors: string[] = str2arr(task?.executors, 'string')

    return <ResultWrapper isLoading={taskLoading} isEmpty={isEmpty(task)}>
        <Grid
            spacing={3}
            container
        >
            <GridItem title={'任务名称'} content={task?.taskName}/>
            <GridItem title={'目标名称'} content={task?.planName}/>
            <GridItem title={'任务状态'} content={task?.status}/>
            <GridItem title={'任务属性'} content={task?.virtue}/>
            <GridItem title={'创建人'} content={task?.creator}/>
            <GridItem title={'创建时间'} content={formatTime("D", task?.createdAt)}/>
            <GridItem title={'执行人'}
                      content={executors?.map((executor: string, index: number) => <Chip key={index} sx={{mr: 0.4}} size={'small'} icon={<Face/>} label={executor}
                                                                                         variant="outlined"/>)}/>
            <GridItem title={'所属目标阶段'} content={task?.planStage}/>
            <GridItem title={'预计工时'} content={task?.duration}/>
            <GridItem title={'优先级'} content={task?.priority}/>
            <GridItem title={'开始时间'} content={formatTime("h", task?.startTime)}/>
            <GridItem title={'结束时间'} content={formatTime("h", task?.endTime)}/>
            <GridItem minHeight={'80px'} size={12} title={'任务描述'} content={task?.description || '-'}/>
        </Grid>
    </ResultWrapper>
};
